import { i18nReducer } from 'react-redux-i18n'
import { combineReducers } from 'redux'

import app from './app'
import compositionFilters from './compositionFilters'
import compositions from './compositions'
import modal from './modal'
import theatres from './theatres'
import theatreFilter from './theatreFilter'
import kdmValidityFilter from './kdmValidityFilter'
import user from './user'
import appliances from './appliances'
import users from './users'
import groups from './groups'

/* export actions */
export * from './theatres'
export * from './compositions'
export * from './modal'
export * from './user'
export * from './compositionFilters'
export * from './app'
export * from './appliances'
export * from './users'
export * from './groups'
export * from './theatreFilter'
export * from './kdmValidityFilter'

export default combineReducers({
  app,
  theatres,
  compositions,
  modal,
  user,
  compositionFilters,
  appliances,
  i18n: i18nReducer,
  users,
  groups,
  theatreFilter,
  kdmValidityFilter
})
